import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ticketApi, { ConversationBody } from "../api/ticketApi";
import { conversationsAtom, workOrderIDAtom } from "../store";
import useToken from "./useToken";

const useConversation = ({ count: count }: { count: number }) => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [conversations, setConversations] = useAtom(conversationsAtom);
  const token = useToken();
  const [workOrderID] = useAtom(workOrderIDAtom);
  const [totalMessageCount, setTotalMessageCount] = useState<number>(0);
  const [ recentMessages, setRecentMessages ] = useState<any[]>([])

  const fetch = async ({ page: page }: { page: number }) => {
    setFetchLoading(true);
    const result = await ticketApi.fetchConversations(
      `${token.token}`,
      workOrderID,
      count,
      page
    );
    setFetchLoading(false);
    if (!result?.ok) {
      setConversations([])
      return toast.error(!result?.problem);
    }
    if (!result.data?.success) {
      setConversations([])
      return toast.error("Error fetching messages");
    }

    setTotalMessageCount(result.data._meta.totalCount);
    setConversations(result.data.data);
  };

  const send = async (data: ConversationBody, page: number, cb?: () => any) => {
    setLoading(true);
    const result = await ticketApi.sendConversation(data, `${token.token}`);
    setLoading(false);
    if (!result.ok) {
      return toast.error(!result.problem);
    }
    if (!result.data?.success) {
      return toast.error(result.data?.data.message);
    }
    cb?.();
    fetch({ page: page });
  };

  return {
    sendMessage: {
      send,
      loading,
    },
    fetchMessages: { fetch, loading: fetchLoading, totalMessageCount, recentMessages },
  };
};

export default useConversation;
